<table *ngIf='col?.length > 0 && row?.length > 0 && show' class='table table-striped table-sm'>
  <thead class='bg-secondary text-white'>
  <tr>
    <th scope='col'></th>
    <th *ngFor='let c of col' class='col-header col-custom' scope='col' id="col_{{c.uuid}}">
      <div class='col-text-vertical'
           container='body'
           ngbPopover='{{c?.label}}'
           placement='top'
           triggers='mouseenter:mouseleave'>
        {{ c?.label }}
      </div>
    </th>
    <th class='w-100'>

    </th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngIf='groupByCategory; then GROUP_BY_CATEGORY; else LIST'></ng-container>
  <ng-template #GROUP_BY_CATEGORY>
    <ng-container *ngFor='let category of categories'>
      <tr>
        <td [colSpan]='this.col?.length + 2' class='matrix-row-category'>{{ category }}</td>
      </tr>

      <tr *ngFor='let r of groupByCategoryMap.get(category)' id="row_{{r.uuid}}">

        <td class='col-label'>
          <div class='label'
               container='body'
               ngbPopover='{{r?.label}}'
               placement='top'
               triggers='mouseenter:mouseleave'>
            {{ r?.label }}
          </div>
          <div class='help'>
            <pt-w-help [help]='r?.help'></pt-w-help>
          </div>
        </td>

        <td *ngFor='let c of col' class='text-center'
            triggers='mouseenter:mouseleave'
            [ngbTooltip]='tooltipData'
            container='body'
            [ngClass]="preview ? '' : 'cell-clickable'"
            (click)='preview ? undefined : toggleCell.emit({row: r.uuid, col: c.uuid})'>

          <ng-template #tooltipData>
            <div class='d-flex flex-column'>
              <span>{{ r.label }}</span>
              <span>{{ c.label }}</span>
            </div>
          </ng-template>

          <ng-container *ngIf='preview'>
            <pt-icon *ngIf='isChecked(r.uuid, c.uuid)' [key]='IconCheck'
                     class='widget-icon-preview-color'
            ></pt-icon>
            <pt-icon *ngIf='!isChecked(r.uuid, c.uuid)' [key]='IconUncheck'
                     class='widget-icon-preview-color-disabled'
            ></pt-icon>
          </ng-container>

          <div *ngIf='!preview' class='form-check form-check-widget'>
            <input
                   [checked]='isChecked(r.uuid, c.uuid)'
                   class='form-check-input cursor-pointer'
                   type='checkbox'>
          </div>
        </td>
        <td>

        </td>
      </tr>
    </ng-container>

  </ng-template>
  <ng-template #LIST>
    <tr *ngFor='let r of row'>
      <td class='col-label'>
        <div class='label'
             container='body'
             triggers='mouseenter:mouseleave'
             ngbPopover='{{r?.label}}'
             placement='top'>
          {{ r?.label }}
        </div>
        <div class='help'>
          <pt-w-help [help]='r?.help'></pt-w-help>
        </div>
      </td>
      <td *ngFor='let c of col' class='text-center'>
        <pt-icon *ngIf='preview && isChecked(r.uuid, c.uuid)' [key]='IconCheck'></pt-icon>
        <div *ngIf='!preview' class='form-check'>
          <input (click)='toggleCell.emit({row: r.uuid, col: c.uuid})'
                 [checked]='isChecked(r.uuid, c.uuid)'
                 class='form-check-input cursor-pointer'
                 type='checkbox'>
        </div>
      </td>
      <td>

      </td>
    </tr>
  </ng-template>

  </tbody>
</table>
